export const defaultProgramHtml = `<p><strong>THÔNG TIN CHI TIẾT CHƯƠNG TRÌNH:</strong></p>
<ul>
  <li>Đối tượng tham gia: Học sinh lớp 11 và 12 các trường Trung học phổ thông trên toàn quốc.</li>
  <li>Thời gian dự thi: Thứ Bảy &amp; Chủ Nhật, ngày 03 - 04/10/2026 (mỗi học sinh sẽ tham gia thi trong 01 buổi).</li>
  <li>Địa điểm thi: Các phòng máy tính chuẩn hóa tại Thư viện Tạ Quang Bửu – Đại học Bách khoa Hà Nội.</li>
  <li>Hình thức thi: Thi online tập trung trên máy tính.</li>
  <li>Lệ phí: HOÀN TOÀN MIỄN PHÍ!</li>
  <li>Thời hạn đăng ký: Hạn cuối đến Thứ Hai, ngày 28/09/2026 (hệ thống có thể đóng sớm hơn nếu đã đủ số lượng chỗ tại phòng máy).</li>
</ul>
<p><strong>LƯU Ý QUAN TRỌNG DÀNH CHO HỌC SINH:</strong></p>
<ul>
  <li>Cam kết tham gia: Học sinh đăng ký cần sắp xếp thời gian để tham gia đầy đủ, đúng giờ.</li>
  <li>Thông tin chính xác: Vui lòng chọn đúng tên trường THPT và điền chính xác thông tin cá nhân để hệ thống ghi nhận và gửi kết quả thi về cho bạn.</li>
  <li>Nhận lịch thi: Thông tin chi tiết về ca thi, thời gian và vị trí phòng thi cụ thể sẽ được gửi trực tiếp qua Email của học sinh trong vòng 03 ngày trước ngày diễn ra trải nghiệm.</li>
</ul>
<p>Học sinh vui lòng điền đầy đủ và chính xác các thông tin theo biểu mẫu dưới đây để hoàn tất đăng ký:</p>`;

export function getProgramHtml(program) {
  if (!program || typeof program !== 'object') {
    return '';
  }
  if (program.html) {
    return program.html;
  }

  const parts = [];
  (program.sections || []).forEach((section) => {
    if (section.title) {
      parts.push(`<p><strong>${section.title}</strong></p>`);
    }
    if (section.items?.length) {
      parts.push(
        `<ul>${section.items.map((item) => `<li>${item}</li>`).join('')}</ul>`,
      );
    }
  });
  if (program.form_note) {
    parts.push(`<p>${program.form_note}</p>`);
  }
  return parts.join('\n');
}
